module.exports = __webpack_public_path__ + "static/media/logo.5a0f1921.png";